<template>
  <div class="modal-message">
    <div class="card" v-loading="loading" element-loading-spinner="qc-spinner">
      <div v-if="title" class="card-header">
        <h4 class="card-title">{{title}}</h4>
        <p v-if="description" class="category">{{description}}</p>
      </div>
      <div class="card-content">
        <div>{{message}}</div>
        <div v-if="message2">{{message2}}</div>
      </div>
      <div class="card-footer row" style="font-size: 120%">
        <div class="col-md-12">
          <button @click="closeAction()" class="btn btn-wd">{{closeText}}</button>
          <span class="pull-right">
            <button v-if="actionText1" @click="loading = doLoading; action1()" class="btn btn-fill btn-wd"><i :class="actionIcon1"></i>&nbsp;{{actionText1}}</button>
            <button v-if="actionText2" @click="loading = doLoading; action2()" class="btn btn-fill btn-wd"><i :class="actionIcon2"></i>&nbsp;{{actionText2}}</button>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'modal-message',
    data () {
      return {
        loading: false
      }
    },
    props: {
      title: String,
      description: String,
      message: String,
      message2: String,
      doLoading: {type: Boolean, default: true},
      closeText: {type: String, default: "Close"},
      closeAction: {type: Function, default() { this.$modal.close() } },
      actionText1: {type: String},
      actionText2: {type: String},
      actionIcon1: {type: String},
      actionIcon2: {type: String},
      action1: {type: Function},
      action2: {type: Function}
    }
  }
</script>

<style>
  .modal-message {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>